module.exports = ".form-check-input {\n  margin-left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/messagecentrals/components/messagecentral.modal.scss
// module id = 583
// module chunks = 1